import React, { forwardRef } from 'react';

import classnames from 'classnames';

import { type SizeType } from '../../../features/config';

import styles from '../Chip.module.scss';

import type { CHIP_STATUS } from '..';

type Props = {
    background: boolean;
    noPadding?: boolean;
    children?: React.ReactNode;
    className?: string;
    color?: string;
    status: CHIP_STATUS;
    statusSize: SizeType;
};

export const StatusChip = forwardRef<HTMLDivElement, Props>(
    ({ background, noPadding, children, className, color, status, statusSize }: Props, ref) => {
        return (
            <div
                ref={ref}
                className={classnames(styles.chip, className, {
                    [styles['chip--no-background']]: !background,
                    [styles['chip--no-padding']]: noPadding
                })}
            >
                <div
                    className={classnames(
                        styles['chip-status'],
                        styles[statusSize],
                        styles[`chip-status--${status}`]
                    )}
                    style={color ? { backgroundColor: color } : {}}
                />
                {children}
            </div>
        );
    }
);

StatusChip.displayName = 'StatusChip';
